<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" id="vol-1-part-1">
<div class="heading heading-with-title heading-without-image" id="vol-1-part-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Part I</h1>
</div>
</div>
</div>
</div>
<div class="text" id="vol-1-part-1-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><i>We never know the true worth of water until the well is dry.</i></p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>— Thomas Fuller, Gnomologia 1732</b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001part001.vue?20e63234